import { css } from "lit";

export const styles = css`
  .col-drag-handle {
    width: 40px;
  }

  .community-tile.reorder-tile {
    flex-direction: row;
    align-items: center;
  }

  .community-tile-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
  }

  td:first-child {
    padding-right: 0;
  }

  .thumbnail {
    height: 64px;
    aspect-ratio: 1 / 1;
    border-radius: var(--sds-size-radius-600);
    overflow: hidden;
    background: var(--sds-color-background-default-secondary);
    transition: background-color 0.2s ease;
  }

  .thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .thumbnail-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--sds-color-icon-default-secondary);
    transition: color 0.2s ease;
  }

  dropdown-menu {
    --dropdown-trigger-border-radius: var(--sds-size-radius-full);
  }

  /* Mobile tile view */
  .community-tile {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
  }

  .community-tile-info {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
    min-width: 0;
  }

  .community-tile-title {
    font-weight: var(--sds-typography-weight-medium);
    font-size: var(--sds-typography-body-size-medium);
    color: var(--sds-color-text-default-default);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .community-tile-type {
    font-size: var(--sds-typography-body-size-small);
    color: var(--sds-color-text-default-secondary);
  }

  .community-tile-stats {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    font-size: var(--sds-typography-body-size-small);
    color: var(--sds-color-text-default-secondary);
    flex-wrap: wrap;
  }

  .community-tile-stats span + span {
    border-left: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    padding-left: var(--sds-size-space-400);
  }

  .community-tile-actions {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-300);
    padding-top: var(--sds-size-space-200);
  }

  .community-tile-actions wow-button[full-width] {
    flex: 1;
  }

  /* Desktop table column widths */
  .col-thumbnail-url {
    width: 80px;
  }

  td.col-title {
    max-width: 200px;
  }

  td.col-title > * {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .col-status {
    width: 110px;
  }

  .col-content-tier {
    width: 80px;
  }

  .col-member-count {
    width: 80px;
  }

  .col-chat-message-count {
    width: 100px;
  }

  .col-link-clicks {
    width: 90px;
  }

  .col-discount-clicks {
    width: 100px;
  }

  .col-action {
    width: 180px;
  }

  .col-action wow-button {
    --wow-button-inner-font-weight: var(--sds-typography-weight-regular);
    white-space: nowrap;
  }

  .col-menu {
    width: 32px;
  }
`;
